import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/home'
import aboutUs from '@/views/aboutUs'
import contact from '@/views/contact'
import application from '@/views/application'
import business from '@/views/business'
import news from '@/views/news'
import join from '@/views/join'
import information from '@/views/information'
import help from '@/views/help'
import details from '@/views/details'
import infoDetail from '@/views/infoDetail'
import businessDetail from '@/views/business-detail'
import newsDetail from '@/views/news-detail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
      meta:{
        layout:'header-footer',
        title: '首页'
      }
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs,
      meta:{
        layout:'header-footer',
        title: '关于我们'
      }
    },
    {
      path: '/business',
      name: 'business',
      component: business,
      meta:{
        layout:'header-footer',
        title: '业务介绍'
      }
    },
    {
      path: '/businessDetail',
      name: 'businessDetail',
      component: businessDetail,
      meta:{
        layout:'header-footer',
        title: '业务介绍子页面'
      }
    },
    {
      path: '/news',
      name: 'news',
      component: news,
      meta:{
        layout:'header-footer',
        title: '新闻资讯'
      }
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: newsDetail,
      meta:{
        layout:'header-footer',
        title: '新闻资讯子页面'
      }
    },
    {
      path: '/join',
      name: 'join',
      component: join,
      meta:{
        layout:'header-footer',
        title: '人才招聘'
      }
    },
    {
      path: '/information',
      name: 'information',
      component: information,
      meta:{
        layout:'header-footer',
        title: '信息披露'
      }
    },
    {
      path: '/infoDetail',
      name: 'infoDetail',
      component: infoDetail,
      meta:{
        layout:'header-footer',
        title: '详情'
      }
    },
    {
      path: '/help',
      name: 'help',
      component: help,
      meta:{
        layout:'header-footer',
        title: '帮助中心'
      },
    },
    {
      path: '/detail',
      name: 'detail',
      component: details,
      meta:{
        layout:'header-footer',
        title: '详情页面'
      },
    },
    {
      path: '/contactUs',
      name: 'contact',
      component: contact,
      meta:{
        layout:'header-footer',
        title: '联系我们'
      }
    },
    {
      path: '/application',
      name: 'application',
      component: application,
      meta:{
        layout:'header-footer',
        title: '应用介绍'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js